'use strict';

function setCookie (name, value, days) {
  var expires = null;

  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toGMTString();
  } else {
    expires = '';
  }

  document.cookie = escape(name) + '=' + escape(value) + expires + '; path=/';
}

function getCookie (name) {
  var cookies = document.cookie.split(';');
  for (var index = 0; index < cookies.length; index++) {
    var cookie = cookies[index];
    var pair = cookie.split('=').map(function (string) {
      return string.trim();
    });

    if (pair[0] === escape(name)) {
      return unescape(pair[1]);
    }
  }
  return null;
}

function eraseCookie (name) {
  setCookie(name, '', -1);
}

module.exports = {
  set: setCookie,
  get: getCookie,
  erase: eraseCookie
};
